(() => {
  const heroes = document.querySelectorAll('[data-echtools-werkzeuge-hero]');

  heroes.forEach((hero) => {
    const slide = hero.closest('.slideshow-slide-werkzeuge');
    const products = hero.querySelector('.echtools-werkzeuge-products');
    const cards = [...hero.querySelectorAll('.echtools-werkzeuge-product')];
    const controls = [...document.querySelectorAll(
      '.slideshow-slide-werkzeuge .echtools-werkzeuge-category, .slideshow-slide-werkzeuge .echtools-werkzeuge-marker'
    )];
    let pinnedFamily = null;
    let previewFamily = null;

    const render = () => {
      const family = previewFamily || pinnedFamily;
      slide.classList.toggle('echtools-werkzeuge-active', Boolean(family));
      products.classList.toggle('has-active', Boolean(family));
      cards.forEach((card) => card.classList.toggle('is-active', card.dataset.family === family));
      controls.forEach((control) => {
        control.classList.toggle('is-active', control.dataset.family === family);
        control.setAttribute('aria-pressed', String(control.dataset.family === pinnedFamily));
      });
    };

    [...cards, ...controls].forEach((element) => {
      element.addEventListener('pointerenter', () => {
        previewFamily = element.dataset.family;
        render();
      });
      element.addEventListener('pointerleave', () => {
        previewFamily = null;
        render();
      });
      element.addEventListener('focus', () => {
        previewFamily = element.dataset.family;
        render();
      });
      element.addEventListener('blur', () => {
        previewFamily = null;
        render();
      });
    });

    controls.forEach((control) => {
      control.addEventListener('click', () => {
        pinnedFamily = pinnedFamily === control.dataset.family ? null : control.dataset.family;
        render();
      });
    });

    slide.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        pinnedFamily = null;
        previewFamily = null;
        render();
      }
    });

    render();
  });
})();
